import styled from "styled-components";


export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
`;

export const LeftContainer = styled.div`
`;
export const RightContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  z-index: 1;

  @media (max-width: 768px) {
    margin-top: -40px;
    justify-content: flex-start;
  }
  @media (max-width: 1024px) {
    margin-top: -40px;
    justify-content: flex-start;
  }

  @media (max-width: 540px) {
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    text-align: center;
  }
  @media (max-width: 425px) {
    display: flex;
    justify-content: flex-start;
  }
`;


export const TabButton = styled.button`
  background: none;
  color: ${(p) => p.theme.colors.lightTextcolor};
  padding: ${(p) => p.theme.spacing.xs} ${(p) => p.theme.spacing.sm};
  border: none;
  cursor: pointer;
  ${(p) =>
    p.selected &&
    `
    background-color:${p.theme.colors.lightTextcolor};
    color:${p.theme.colors.darkBlack};
    border-radius:${p.theme.radius.xl};
    font-weight:${p.theme.font.weight.bold};
  `}
`;

export const Input = styled.input`
  width: 200px;
  background-color: ${(p) => p.theme.colors.green};
  border: none;
  outline: none;
  padding: ${(p) => p.theme.spacing.xs} ${(p) => p.theme.spacing.lg}
    ${(p) => p.theme.spacing.xs} ${(p) => p.theme.spacing.xs};
  border-radius: ${(p) => p.theme.radius.xl};
  color: ${(p) => p.theme.colors.white};
  height: 40px;

  ::placeholder {
    color: ${(p) => p.theme.colors.lightTextcolor};
  }
  @media (max-width: ${(p) => p.theme.screen.sm}) {
    width: 100%;
  }
  @media (max-width: ${(p) => p.theme.screen.xxs}) {
    margin-bottom: ${(p) => p.theme.spacing.sm};
  }
`;

export const FilterButton = styled.button`
  background-color: ${(p) => p.theme.colors.green};
  border: none;
  width: 120px;
  color: ${(p) => p.theme.colors.white};
  border-radius: ${(p) => p.theme.radius.xl};
  margin-right: ${(p) => p.theme.spacing.xs};
  cursor: pointer;
  display: flex;
  height: 40px;
  max-height: 40px;
  align-items: center;
`;

export const InputWrapper = styled.div`
  position: relative;
  @media (max-width: 425px) {
    width: 50%;
  }
`;
export const IconWrapper = styled.div`
  position: absolute;
  top: ${(p) => p.theme.spacing.xxs};
  right: -${(p) => p.theme.spacing.xxs};
`;

export const ImageWrapper = styled.div`
  background-color: #fff;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${(p) => p.theme.spacing.xs};
`;

export const ConnectWallet = styled.button`
  color: #fece00;
  border-radius: 30px;
  padding: 10px 16px;
  margin: 0 10px;
  background: transparent;
  border: 1px solid #fece00;
  font-size: 16px;
  cursor: pointer;
  @media (max-width: 500px) {
    padding: 10px 7px;
    margin: 0px 3px;
    font-size: 14px;
  }
`;
export const FilterBtnWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Icon = styled.img`
  width: 16px;
  @media (min-width: 1600px) {
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  padding-bottom: 10px;
  @media (max-width: 768px) {
    padding-bottom: 0;
  }
  @media (max-width: 1024px) {
    padding-bottom: 0;
  }
`;
